import { INVITATION_PATH, RESET_PATH, SIGN_IN_PATH } from '@zevik/schemas';

/**
 * Which page the console is showing, read off the path
 * (docs/DECISIONS.md ZD-118).
 *
 * The three credential paths are `@zevik/schemas`' constants and nothing
 * else: the API builds a link from the same three, and a link in a sent email
 * outlives the deployment that sent it (ZD-117 §5). Every other path is the
 * workspace, because `not_found_handling: single-page-application` serves
 * this bundle at any path and the workspace is what the bundle is.
 *
 * A trailing slash is the same page — a person retyping a link from an email
 * adds one — and nothing else is normalised, because a path that differs in
 * any other way is not one of ours.
 */
export type Page = 'workspace' | 'sign-in' | 'invitation' | 'reset';

const CREDENTIAL_PAGES: ReadonlyMap<string, Page> = new Map([
  [SIGN_IN_PATH, 'sign-in'],
  [INVITATION_PATH, 'invitation'],
  [RESET_PATH, 'reset'],
]);

export function pageFor(pathname: string): Page {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/u, '') : pathname;
  return CREDENTIAL_PAGES.get(path) ?? 'workspace';
}
